
import { styled } from '@mui/material/styles';
import Box from "@mui/material/Box";

export const MainBox = (props) => <Box component="main" {...props} />;

const Main = styled(MainBox, {
    shouldForwardProp: (prop) => !['open', 'padding', 'drawerWidth'].includes(prop)
})(
    ({ theme, padding = false, drawerWidth = 0, open = false }) => ({
        padding: padding ? theme.spacing(3) : 0,
        position: 'relative',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

export default Main;
